import { getLockedCalendarEventsStore } from 'owa-calendar-events-store';
import { addCalendarItems } from 'owa-calendar-surface-dategrid';
import { DateRange } from 'owa-datetime-utils';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getFreeBusySurfaceItems from './getFreeBusySurfaceItems';
import { getDefaultCalendar, getCalendarIdByFolderId } from 'owa-calendar-cache';
import { calendarEvent as convertToCalendarEvent } from 'owa-calendar-event-converter';
import { getAvailabilityFunction, PageQueryResponse } from 'owa-availability-service';
import { userDate } from 'owa-datetime';
import { getScenarioStore } from 'owa-day-grid-core-schema';

export default async function populateDayDataWithFreeBusy(
    scenarioId: string,
    newFolderIds?: string[],
    newDateRange?: DateRange,
    newSelectionItem?: CalendarEvent,
    newShowSelectionItem?: boolean
) {
    const viewState = getScenarioStore(scenarioId);
    const { eventsCacheLockId, folderIds, dateRange, selectionItem, showSelectionItem } = viewState;
    newFolderIds = newFolderIds || folderIds;
    newDateRange = newDateRange || dateRange;
    newSelectionItem = newSelectionItem || selectionItem;
    newShowSelectionItem = newShowSelectionItem == undefined ? showSelectionItem : false;
    let itemsToAdd = getFreeBusySurfaceItems(dateRange);

    const filterItemsFunction = item => {
        if (newShowSelectionItem) {
            return true;
        } else {
            return item.ItemId && item.ItemId.Id !== selectionItem.ItemId.Id;
        }
    };

    if (newSelectionItem?.IsAllDayEvent && newShowSelectionItem) {
        itemsToAdd.push(newSelectionItem);
    }

    let callingGetAvailability = false;
    let mailboxId = null;

    // Scheduling grid - For new event on user's default calendar, this will match what we currently do for Scheduling Assistant.
    // We will call GetUserInternalAvailability for user's default calendar instead of fetching items from Calendar Surface/GetCalendarView.
    if (folderIds.length === 1) {
        const calendarId = getCalendarIdByFolderId(folderIds[0]);
        mailboxId = calendarId ? calendarId.mailboxInfo.userIdentity : undefined;

        const defaultCalendar = mailboxId ? getDefaultCalendar(mailboxId) : undefined;
        const defaultCalendarId = defaultCalendar ? defaultCalendar.calculatedFolderId : undefined;

        if (defaultCalendarId === folderIds[0]) {
            callingGetAvailability = true;
            const onGetAvailability = (result: PageQueryResponse) => {
                const userAvailability = result[mailboxId];

                if (userAvailability?.Items) {
                    let freeBusyCalendarEvents = userAvailability.Items.map(item =>
                        convertToCalendarEvent(item, calendarId.mailboxInfo)
                    );

                    itemsToAdd.push(...freeBusyCalendarEvents);
                }
                addCalendarItems(
                    itemsToAdd.filter(filterItemsFunction),
                    viewState,
                    true /*replace all*/
                );
            };

            getAvailabilityFunction(
                // Our current converter infra expects all service CalendarItem objects
                // To be relative to the user's local time zone. Parse the provided dates into user dates.
                userDate(dateRange.start),
                userDate(dateRange.end),
                [mailboxId],
                onGetAvailability,
                true,
                calendarId.mailboxInfo
            );
        }
    }

    if (!callingGetAvailability) {
        const eventsStore = getLockedCalendarEventsStore(eventsCacheLockId);
        for (let folderId of folderIds) {
            await eventsStore
                .fetchCalendarEventsForDateRange(folderId, dateRange)
                .fetchPromise.then(items => items && itemsToAdd.push(...items));
        }

        addCalendarItems(itemsToAdd.filter(filterItemsFunction), viewState, true /*replace all*/);
    }
}
